module.exports = __webpack_public_path__ + "static/assets/3f9cf4ad57c870d5772d62f885d1ae23.png";